import React from "react"
import { Reveal, Fade } from "react-reveal"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import ClientStart from "../../components/ClientStart/ClientStart"
import ClientsSlider from "../../components/Slider/Clients"
import software_project from "../../../static/services/software-project.jpg"

const SoftwareDevelopmentPage = () => (
  <Layout>
    <SEO title="Software Development" />

    <div className="hero-section s-section">
      <div className="hero-wrapper other">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-h1">Software Development</h1>
            <Reveal left>
              <p className="hero-p">
                We accelerate your operations by building Web and Mobile
                experiences
              </p>
            </Reveal>
          </div>

          <div className="hero-content index-header-img ">
            <Fade right>
              <img
                src={software_project}
                alt="software project"
                className="hero-img rounded-pill"
              />
            </Fade>
          </div>
        </div>
      </div>
      <div className="container index-client ">
        <ClientsSlider />
      </div>
    </div>
    <div className="section border-bottom-0 why-section">
      <div className="container pt-0">
        <h1 className="hero-h1"> How We Do It</h1>
        <p>
          Accelerate your projects delivery using our simple three-step
          application development process.
        </p>
      </div>
      <div className="container">
        <div className="row s-bullets-wrapper">
          <div className="col-lg-4 col-md-6 col-sm-12 mt-5">
            <div className="s-bullets-steps hr-line">1</div>
            <h3 className="bullets-title"> Requirements Gathering</h3>
            <ul className="bullets-dots">
              <li>Requirements Definition</li>
              <li>Analyzing the requirements</li>
              <li>Initial Design</li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12 mt-5">
            <div className="s-bullets-steps hr-line">2</div>
            <h3 className="bullets-title"> Development Testing</h3>
            <ul className="bullets-dots">
              <li>Frontend and backend development</li>
              <li>Regular client feedback</li>
              <li>Deployment</li>
              <li>Testing</li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12 mt-5">
            <div className="s-bullets-steps">3</div>
            <h3 className="bullets-title"> Support and Maintenance</h3>
            <ul className="bullets-dots">
              <li>SLA based support</li>
              <li>Operational suport where needed</li>
              <li>On-going support </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <ClientStart />
  </Layout>
)

export default SoftwareDevelopmentPage
